import PropTypes from "prop-types";
import { useEffect } from "react";
import Head from "next/head";
// import ModifySearchWidget from '../components/ModifySearchWidget';
// import PwaModifySearchWidget from '../components/PwaModifySearchWidget';
// import { fetchFares } from '../utils/apiHelper';
import parse from "html-react-parser";
import { handleLocalStorageInGdpr } from "MMT-UI/storages/client/localStorage";
import GdprConsentForm from "MMT-UI/GdprConsentForm";
import { tokenReplace } from "../utils/Tokens";
import { executeScriptString } from "../utils/CommonUtils";
import { initializeDocumentWriteInterceptor } from "../utils/analyticsUtil";
import { appendHead } from "../components/offers/Head";
import { appendHeadRouteDT } from "../components/FlightRouteDT/Head";
import { getAdobeScriptMMT, getAdobeScriptGI } from "@mmt/event-logger";
import { initAndGetAnalyticsSdk } from "@mmt/event-logger";
import { createDefaultEventData } from "../utils/eventDataUtil";
import {
  destinationPickerDTPageType,
  fareFinderDTPageType,
  flightIsm2PageType,
  flightsIsmDTNewPageType,
  flightsStaticPageType,
  IS_PROD,
  ismPageServicePageType,
  noCommonHeaderPageType,
} from "../utils/Constants";
import { appendHeadRoutePWA } from "../components/FlightRoutePWA/Head";
import { appendHeadFareFinderDT } from "../components/FareFinderDT/Head";
import { appendHeadDistanceDT } from "../components/FlightDistanceDT/Head";
import { appendHeadCityPWA } from "../components/CityPWA/Head";
import { appendHeadCityDT } from "../components/CityDT/Head";
import HeaderCityDT from "../components/CityDT/Header";
import { appendHeadCityCountryDT } from "../components/CityCountryDT/Head";
import HeaderDistanceDT from "../components/FlightDistanceDT/Header";
import { appendHeadDistancePWA } from "../components/FlightDistancePWA/Head";
import dynamic from "next/dynamic";
import { giThemeMinCss } from "../utils/stylesUtil/giTheme";

const ClientHeader = dynamic(() => import("../components/CommonHeaderDT/ClientHeader"));

const ClientHeaderGI = dynamic(() => import("../components/CommonHeaderDT/ClientHeaderGI"));

// Dynamic imports for Footer components
const FooterRouteDT = dynamic(() => import("../components/FlightRouteDT/Footer"));
const FooterRoutePWA = dynamic(() => import("../components/FlightRoutePWA/Footer"));
const FooterFareFinderDT = dynamic(() => import("../components/FareFinderDT/Footer"));
const FooterCityDT = dynamic(() => import("../components/CityDT/Footer"));
const FooterDistanceDT = dynamic(() => import("../components/FlightDistanceDT/Footer"));
const FooterDistancePWA = dynamic(() => import("../components/FlightDistancePWA/Footer"));
const FooterCityPWA = dynamic(() => import("../components/CityPWA/Footer"));
const FooterOffers = dynamic(() => import("../components/offers/Footer"));

if (typeof window !== "undefined") handleLocalStorageInGdpr();

export default function Layout({ children }) {
  const { props } = children || {};
  const { data, localeSettings } = props || {};
  const isMobile = data?.isDeviceMobile;
  data.region = localeSettings?.region;

  const {
    pageType = "",
    tokens = {},
    title = "",
    description = "",
    keywords = "",
    alternate = "",
    shortlink = "",
    next = "",
    prev = "",
    canonical = "",
    appConfig = {},
    alternate_href: alternateHref = "",
    preloadJS = "",
    currentUrl = "",
    isGoibibo = false,
    giOfferList = [],
    analytics = "",
    xdmEvents = [],
  } = data;
  // const [context, setContext] = useState({});
  // let responseProps = data;
  const mapPath = appConfig?.liveMode
    ? `${appConfig.jsPath}/js/flight-assets/map.js?v=${appConfig.resourceVersion}`
    : "/js/core/map.js";

  useEffect(() => {
    if (flightIsm2PageType[pageType]) {
      const mapScript = document?.createElement("script");
      mapScript.src = `${mapPath}`;
      mapScript.defer = true;
      document?.body.append(mapScript);
    }
  }, []);

  useEffect(() => {
    if (analytics && analytics !== "") {
      // Initialize document.write interceptor before executing analytics scripts
      initializeDocumentWriteInterceptor();
      executeScriptString(analytics, isGoibibo);
    }
  }, [analytics]);

  let alternateHTML = "";
  let alternateHrefHTML = "";
  let canonicalHTML = <></>;
  let preloadJSHTML = "";

  let jsPath;
  if (appConfig && appConfig.liveMode) {
    jsPath = `https://jsak.mmtcdn.com/flights-cms-seo/assets/_next/static/js`;
  } else {
    jsPath = "http://localhost:3000/_next/static/js";
  }

  try {
    if (preloadJS) {
      preloadJSHTML = parse(preloadJS);
    } else {
      preloadJSHTML = "<></>";
    }
  } catch (error) {
    preloadJSHTML = "<></>";
    console.error("Error parsing preloadJS HTML", error);
  }
  try {
    if (alternate) {
      alternateHTML = parse(alternate);
    } else {
      alternateHTML = "<></>";
    }
  } catch (error) {
    alternateHTML = "<></>";
    console.error("Error parsing alternate HTML", error);
  }

  const parsedLinks = parse(alternateHref, {
    replace: (domNode) => {
      if (domNode.name === "link") {
        return (
          <link
            key={`${domNode.attribs.href}-${domNode.attribs.hreflang}`}
            rel={domNode.attribs.rel}
            href={domNode.attribs.href}
            hreflang={domNode.attribs.hreflang}
          />
        );
      }
    },
  });

  const parsedCanonical = parse(canonical, {
    replace: (domNode) => {
      if (domNode.name === "link") {
        return (
          <link
            key={`${domNode.attribs.href}-${domNode.attribs.hreflang}`}
            rel={domNode.attribs.rel}
            href={domNode.attribs.href}
            hreflang={domNode.attribs.hreflang}
          />
        );
      }
    },
  });

  const xdmEventData = createDefaultEventData({ ...data, localeSettings });

  useEffect(() => {
    if (ismPageServicePageType[pageType]) return;
    try {
      const AnalyticsSdk = initAndGetAnalyticsSdk({
        org: isGoibibo ? "GI" : "MMT",
      });
      AnalyticsSdk.pushToAll(xdmEventData.eventData, xdmEventData.extraOptions);
    } catch (error) {
      console.error("Error initializing Analytics SDK:", error);
    }
  }, []);

  return (
    <>
      {/* {!isMobile && <Header headerMessage={header} ccde={ccde} />} */}
      <Head>
        <title>{tokenReplace(title, tokens)}</title>
        <meta name="description" content={tokenReplace(description, tokens)} />
        <meta property="og:title" content={tokenReplace(title, tokens)} />
        <meta property="og:description" content={tokenReplace(description, tokens)} />
        <meta
          property="og:image"
          content={
            isGoibibo
              ? "https://gos3.ibcdn.com/dweb2app-qr-logo-1664447597.png"
              : "https://promos.makemytrip.com/Growth/Images/3x/mmt_dt_header_icon_3x.png"
          }
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={currentUrl} />
        <meta name="twitter:card" content="summary" />
        <meta property="twitter:title" content={tokenReplace(title, tokens)} />
        <meta property="twitter:description" content={tokenReplace(description, tokens)} />
        <meta
          property="twitter:image"
          content={
            isGoibibo
              ? "https://gos3.ibcdn.com/dweb2app-qr-logo-1664447597.png"
              : "https://promos.makemytrip.com/Growth/Images/3x/mmt_dt_header_icon_3x.png"
          }
        />
        <meta name="keywords" content={tokenReplace(keywords, tokens)} />
        <meta charSet="utf-8" />
        <meta httpEquiv="x-dns-prefetch-control" content="on" />
        <link
          rel="shortcut icon"
          type="image/x-icon"
          href={
            isGoibibo
              ? "https://jsak.goibibo.com/pwa_v3/pwa_growth/images/favicon.208fb93a.ico"
              : "https://imgak.mmtcdn.com/seo/hotels/sites/all/themes/hotel_responsive/favicon.ico"
          }
        />
        {alternateHTML}
        <link rel="shortlink" href={tokenReplace(shortlink, tokens)} />
        <link rel="dns-prefetch" href="//cssak.mmtcdn.com" />
        <link rel="dns-prefetch" href="//jsak.mmtcdn.com" />
        <link rel="dns-prefetch" href="//imgak.mmtcdn.com" />
        {next && next.length > 0 ? <link rel="next" href={tokenReplace(next, tokens)} /> : <></>}
        {prev && prev.length > 0 ? <link rel="prev" href={tokenReplace(prev, tokens)} /> : <></>}
        <meta name="MobileOptimized" content="width" />
        <meta name="HandheldFriendly" content="true" />
        <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
        <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=5.0" />
        <meta httpEquiv="cleartype" content="on" />
        <meta name="theme-color" media="(prefers-color-scheme: light)" content="white" />
        <meta name="theme-color" media="(prefers-color-scheme: dark)" content="black" />
        <link
          rel="apple-touch-icon"
          type="image/png"
          sizes="256x256"
          href={
            isGoibibo
              ? "https://jsak.goibibo.com/pwa_v3/pwa_growth/images/favicon-16x16.8f237874.png"
              : "https://imgak.mmtcdn.com/pwa/assets/img/mmt_launcher_192x192.png"
          }
        />
        {appConfig?.liveMode === true ? (
          <link
            rel="manifest"
            href={`https://jsak.mmtcdn.com/seo/hotels-new/seo/manifest.json?v=${appConfig.resourceVersion}`}
          />
        ) : (
          <link rel="manifest" href="/manifest.json" />
        )}
        {isGoibibo ? <style dangerouslySetInnerHTML={{ __html: giThemeMinCss }}></style> : ""}
        {pageType === "offerPage" && appendHead(data)}
        {flightsIsmDTNewPageType[pageType] && !isMobile && appendHeadRouteDT(data)}
        {flightsIsmDTNewPageType[pageType] && isMobile && appendHeadRoutePWA(data)}
        {fareFinderDTPageType[pageType] && !isMobile && appendHeadFareFinderDT(data)}
        {flightIsm2PageType[pageType] && !isMobile && appendHeadDistanceDT(data)}
        {flightIsm2PageType[pageType] && isMobile && appendHeadDistancePWA(data)}
        {flightsStaticPageType[pageType] && !isMobile && appendHeadCityDT(data)}
        {flightsStaticPageType[pageType] && isMobile && appendHeadCityPWA(data)}
        {destinationPickerDTPageType[pageType] && !isMobile && appendHeadCityCountryDT(data)}
      </Head>
      <Head>{parsedLinks}</Head>
      <Head>{parsedCanonical}</Head>
      <Head>{preloadJSHTML}</Head>
      {/* {isMobile ? <PwaModifySearchWidget data={data} /> : <ModifySearchWidget data={responseProps} />} */}
      {/* <section className="midContainer">{children}</section> */}
      {!isMobile && noCommonHeaderPageType[pageType] && !isGoibibo && (
        <ClientHeader localeSettings={localeSettings} data={data} />
      )}
      {!isMobile && isGoibibo && noCommonHeaderPageType[pageType] && <ClientHeaderGI />}
      {!isMobile && flightsStaticPageType[pageType] && <HeaderCityDT data={data} />}
      {!isMobile && flightIsm2PageType[pageType] && <HeaderDistanceDT data={data} />}
      {/* {isMobile && flightIsm2PageType[pageType] && <HeaderDistancePWA data={data} />} */}
      <main>{children}</main>
      {pageType === "offerPage" && <FooterOffers data={data} />}
      {flightsIsmDTNewPageType[pageType] && !isMobile && <FooterRouteDT data={data} />}
      {flightsIsmDTNewPageType[pageType] && isMobile && <FooterRoutePWA data={data} />}
      {fareFinderDTPageType[pageType] && !isMobile && <FooterFareFinderDT data={data} />}
      {flightsStaticPageType[pageType] && !isMobile && <FooterCityDT data={data} />}
      {flightsStaticPageType[pageType] && isMobile && <FooterCityPWA data={data} />}
      {flightIsm2PageType[pageType] && !isMobile && <FooterDistanceDT data={data} />}
      {flightIsm2PageType[pageType] && isMobile && <FooterDistancePWA data={data} />}

      <script
        dangerouslySetInnerHTML={{
          __html: `window.localeSettings = ${JSON.stringify(localeSettings)};`,
        }}
      />

      <script
        src={
          isGoibibo
            ? getAdobeScriptGI(IS_PROD ? "production" : "development")
            : getAdobeScriptMMT(IS_PROD ? "production" : "development")
        }
        async
      />

      {isGoibibo ? (
        <>
          {/* Offers Block Script */}
          {giOfferList?.length ? (
            <>
              <script
                dangerouslySetInnerHTML={{
                  __html: `
                  window.giOfferCurrentIndex = 0;
                  window.giOfferList = ${JSON.stringify(giOfferList)}
                `,
                }}
              />
              <script type="text/javascript" src={`${jsPath + `/offersGI.min.js`}`} />
            </>
          ) : null}
        </>
      ) : (
        <GdprConsentForm isPWA={isMobile} lob="FLIGHTS" />
      )}
    </>
  );
}

Layout.propTypes = {
  // eslint-disable-next-line react/require-default-props, react/forbid-prop-types
  children: PropTypes.object,
};
